import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "EstadoCivilPage",
    data() {
        let ss = new MainService();
        return {
            msg: "EstadoCivilPage",
            ss: ss,
            auth: {},

            ajax: {
                "url": ss.indexEstadoCivil(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'EstadoCivil', name: 'EstadoCivil', title: 'Estado Civil' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción' },
                //{ data: 'Rol', name: 'Rol', title: 'Rol' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            rols: [],
            estadocivils: [],
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            estadocivil: {},
            
        };
    },
    methods: {
              
        newEstadoCivil() {
            this.estadocivil = {};
            this.$refs['frm-estadocivil'].show();
            // console.log("hhhhola")
        },
        showEstadoCivil(id) {
            this.isLoading=true;
            this.ss.showEstadoCivil(id).then(
                (result) => {
                    let response = result.data;
                    this.estadocivil = response.data;
                    this.$refs['view-estadocivil'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editEstadoCivil() {
            this.$refs['frm-estadocivil'].show();
            this.$refs['view-estadocivil'].hide();
        },
        cancelEstadoCivil() {
            if (this.estadocivil.id) {
                this.$refs['view-estadocivil'].show();
            }
            this.$refs['frm-estadocivil'].hide();
        },
        saveEstadoCivil() {
            this.ss.storeEstadoCivil(this.estadocivil).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-estadocivil'].hide();
                    this.$refs['datatable-estadocivil'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteEstadoCivil() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyEstadoCivil(this.estadocivil)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-estadocivil'].hide();
                                this.$refs['datatable-estadocivil'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        cambiopassword() {
            this.$refs['view-estadocivil'].hide();
            this.$refs['view-password'].show();
        },
        cancelPassword() {
            this.$refs['view-password'].hide();
            this.$refs['view-estadocivil'].show();
        },
        changePassword() {
            this.password.EstadoCivil = this.estadocivil.id;
            this.ss.changePassword(this.password)
                .then( result => {
                    let response = result.data;
                    if ( response.success ) {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Correcto',
                                variant: 'success',
                                autoHideDelay: 5000
                            }
                        )
                        this.$refs['view-password'].hide();
                        this.$refs['view-estadocivil'].show();
                    } else {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Oops',
                                variant: 'danger',
                                autoHideDelay: 5000
                            }
                        )
                    }
                })
                .catch( error => {
                    console.log( error );
                    this.$bvToast.toast(
                        'Error al guardar el registro',
                        {
                            title: 'Oops',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                    this.errorBag = error.data.errors;
                })
        },
        draw() {
            window.$('.btn-datatable-EstadoCivil').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showEstadoCivil(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } 
    }
};
